{
  "dirty": false,
  "raw": "d9b915a",
  "hash": "d9b915a",
  "distance": null,
  "tag": null,
  "semver": null,
  "suffix": "d9b915a",
  "semverString": null
}